











































































import { Component, Mixins, Prop, Provide, Watch } from 'vue-property-decorator';
import { TForm } from '@/plugins/podolib/lib/types';
import { TAcquisition, TComment, TGraph, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { Severity } from '@sentry/types';
import Dialog from '@/plugins/podolib/services/helper/mixins/dialog';

type TFields = {
  comment: {
    value: string;
  };
};
@Component({
  components: { Dialog },
})
export default class PatientAcquisitionCommentsEdit extends Mixins(MixinDialog) {
  @Prop({ required: true }) private patientId!: TEntity<TPatient>['_id'];
  @Prop({ required: true }) private acquisitionId!: TAcquisition['_id'];
  @Prop({ required: false }) private select!: TGraph;
  @Prop({ required: true }) private comment!: TComment;

  @Provide() form: TForm<TFields> = {
    fields: {
      comment: {
        value: '',
      },
    },
    pending: false,
    error: null,
    success: false,
  };

  @Watch('dialog')
  onDialogChanged(state: boolean) {
    if (state) {
      // Populate form
      this.form.fields.comment.value = this.comment.comment;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
    }
  }

  @Watch('form.fields', { deep: true })
  onFormFieldsDeeplyChanged(newFormFields: TFields) {
    // To avoid flash css switch
    if (!this.dialog) return;
    // Reset flags
    this.form.success = false;
    this.form.error = null;
  }

  async save() {
    try {
      // @ts-ignore
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
      // Set 'pending' flag
      this.form.pending = true;
      await this.$pdc.repository!.patchRessource({
        ressource: 'acquisitions',
        params: {
          _id: this.acquisitionId,
        },
        data: {
          'comments.$.comment': this.form.fields.comment.value,
        },
        additionnalQuery: {
          'comments._id': this.comment._id,
        },
      });
      this.form.success = true;
    } catch (e) {
      // Set 'error' flag
      this.form.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }
}
